import { useState, useEffect, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { useCadaverService } from 'hooks/useCadaverService'

export const useInumarCadaver = (props) => {
  const { route, idCadaver } = props
  const router = useRouter()
  const cadaverService = useCadaverService()

  const [formValues, setFormValues] = useState({
    dataObito: null,
    dataInumacao: new Date(),
    cemiterio: '',
    localizacao: '',
    cemiterioAdm: '',
    cemiterioAdmTipoDoc: '',
    cemiterioAdmDoc: '',
    orgaoExpedidorCemiterioAdm: '',
    testemunhaA: '',
    testemunhaATipoDoc: '',
    testemunhaADoc: '',
    testemunhaAOrgaoExpedidor: '',
    testemunhaB: '',
    testemunhaBTipoDoc: '',
    testemunhaBDoc: '',
    testemunhaBOrgaoExpedidor: '',
  })

  const [formErrors, setFormErrors] = useState({})
  const [agentes, setAgentes] = useState([])
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [espelhoAberto, setEspelhoAberto] = useState(false)

  // Validação reativa baseada nas chaves do schema original
  useEffect(() => {
    const errors = {}
    if (!formValues.cemiterio || !formValues.cemiterio.trim()) {
      errors.cemiterio = ['O cemitério é obrigatório']
    }
    if (!formValues.localizacao || !formValues.localizacao.trim()) {
      errors.localizacao = ['A localização é obrigatória']
    }
    if (!formValues.dataInumacao) {
      errors.dataInumacao = ['A data da inumação é obrigatória']
    }
    if (!formValues.cemiterioAdm || !formValues.cemiterioAdm.trim()) {
      errors.cemiterioAdm = ['O nome é obrigatório']
    }
    if (!formValues.cemiterioAdmTipoDoc) {
      errors.cemiterioAdmTipoDoc = ['O tipo de documento é obrigatório']
    }
    if (!formValues.cemiterioAdmDoc || !formValues.cemiterioAdmDoc.trim()) {
      errors.cemiterioAdmDoc = ['O documento é obrigatório']
    }
    setFormErrors(errors)
  }, [
    formValues.cemiterio,
    formValues.localizacao,
    formValues.dataInumacao,
    formValues.cemiterioAdm,
    formValues.cemiterioAdmTipoDoc,
    formValues.cemiterioAdmDoc,
  ])

  const handleChangeCampo = useCallback((event) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }, [])

  const handleChangeWithModification = useCallback((event, modifier) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: modifier ? modifier(value) : value }))
  }, [])

  const handleChangeNewValueByNameProperty = useCallback((event, newValue, name) => {
    setFormValues((prev) => ({ ...prev, [name]: newValue }))
  }, [])

  const handleChangeCampoData = useCallback((name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }, [])

  const handleChangeAgentes = useCallback((value) => {
    if (value.length > 2) {
      return
    }
    setAgentes(value)
  }, [])

  const confirmarOperacao = useCallback(async () => {
    const id_cadaver = route.origem === 'CADAVER' ? idCadaver : null

    const dados = {
      dataObito: formValues.dataObito || null,
      dataInumacao: formValues.dataInumacao || null,
      cemiterio: formValues.cemiterio || null,
      localizacao: formValues.localizacao || null,
      cemiterioAdm: formValues.cemiterioAdm || null,
      cemiterioAdmTipoDoc: formValues.cemiterioAdmTipoDoc || null,
      cemiterioAdmDoc: formValues.cemiterioAdmDoc || null,
      orgaoExpedidorCemiterioAdm: formValues.orgaoExpedidorCemiterioAdm || null,
      agentes,
      nomeTestemunhaA: formValues.testemunhaA || null,
      testemunhaATipoDoc: formValues.testemunhaATipoDoc || null,
      testemunhaADoc: formValues.testemunhaADoc || null,
      testemunhaAOrgaoExpedidor: formValues.testemunhaAOrgaoExpedidor || null,
      nomeTestemunhaB: formValues.testemunhaB || null,
      testemunhaBTipoDoc: formValues.testemunhaBTipoDoc || null,
      testemunhaBDoc: formValues.testemunhaBDoc || null,
      testemunhaBOrgaoExpedidor: formValues.testemunhaBOrgaoExpedidor || null,
      id_cadaver,
    }

    await cadaverService.inumarCadaver(dados, setProcessandoOperacao)
    router.history.push(`/casos/caso/cadaver/detalhar/${idCadaver}`)
  }, [formValues, agentes, route.origem, idCadaver, router.history])

  const hasError = useCallback((name) => Boolean(formErrors[name]), [formErrors])

  return {
    formValues,
    formErrors,
    agentes,
    processandoOperacao,
    espelhoAberto,
    setEspelhoAberto,
    handleChangeCampo,
    handleChangeWithModification,
    handleChangeNewValueByNameProperty,
    handleChangeCampoData,
    handleChangeAgentes,
    confirmarOperacao,
    hasError,
    router,
  }
}
